import React from "react";
import { useAbTests } from "src/context/AbTestsProvider";

interface Props {
  testName: string;
  variantA: React.ReactNode;
  variantB: React.ReactNode;
  control: React.ReactNode;
}
const ABTest = ({ testName, variantA, variantB, control }: Props) => {
  const variant = useAbTests((tests) => tests[testName]);

  if (variant === "Variant A") {
    return variantA;
  }

  if (variant === "Variant B") {
    return variantB;
  }

  return control;
};

export default ABTest;
